import React, { useState, useEffect, setGlobal } from "reactn";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

// components
import FormGroup from "shared-anpost-components/components/form/form_group/FormGroup";
import InputGroup from "shared-anpost-components/components/form/input_group/InputGroup";
import Tabs from "shared-anpost-components/components/tabs/Tabs";
import Tab from "shared-anpost-components/components/tab/Tab";
import AddressInternational from "./international/addressInternational";
import AddressLookUp from "./AddressLookUp";

import appHooks from "../../../hooks/appHook";
import addressHooks from "../../../hooks/addressHooks";

const AddressTemplate = ({ showText, handleBlur, handleKeyup, handleChange, errors, includeNickName, settings }) => {
    const [addressLoaded, setAddressLoaded] = useState(false);
    const { values } = appHooks();
    const { addressObj } = addressHooks();

    const setCurrentTab = natOrInt => {
        values[`${settings.id}NatOrInternational`] = natOrInt;

        // if it's an international address then it's a manual address
        values[`${settings.id}Manual`] = natOrInt === "international";

        // reset the country
        if (natOrInt === "national") {
            values[`${settings.id}intCountry`] = "Ireland";
            values[`${settings.id}intCountryCode`] = "IE";
            values[`${settings.id}City`] = "";
        }

        if (natOrInt === "international") {
            // restet country values if international and its set to Ireland
            if (values[`${settings.id}intCountry`] === "Ireland") {
                values[`${settings.id}intCountry`] = "";
                values[`${settings.id}intCountryCode`] = "";
                values[`${settings.id}Town`] = "";
                values[`${settings.id}County`] = "";
                values[`${settings.id}Addresslineone`] = "";
                values[`${settings.id}Addresslinetwo`] = "";
                values[`${settings.id}Addresslinethree`] = "";
                values[`${settings.id}Addresslinefour`] = "";
                values[`${settings.id}PostCode`] = "";
            }
        }

        setGlobal({
            values
        });
        setAddressLoaded(true);
    };

    const addressLookupLoad = () => {
        // if editing, set the edit Id
        if (addressObj[settings.id] && addressObj[settings.id].id) {
            values[`${settings.id}EditId`] = addressObj[settings.id].id;
        } else {
            values[`${settings.id}EditId`] = null;
        }

        // reset manualEntry flag when address lookup loads
        values.manualEntry = false;
    };

    useEffect(() => {
        setCurrentTab(values[`${settings.id}NatOrInternational`] || "national");
    }, []);

    return (
        <>
            {addressLoaded && (
                <FormGroup>
                    {settings.international && (
                        <>
                            <InputGroup>
                                <Tabs defaultIndex={values[`${settings.id}NatOrInternational`]}>
                                    <Tab
                                        active={values[`${settings.id}NatOrInternational`] === "national"}
                                        click={e => {
                                            e.preventDefault();
                                            setCurrentTab("national");
                                        }}
                                    >
                                        Irish address
                                    </Tab>
                                    <Tab
                                        active={values[`${settings.id}NatOrInternational`] === "international"}
                                        click={e => {
                                            e.preventDefault();
                                            setCurrentTab("international");
                                        }}
                                    >
                                        International address
                                    </Tab>
                                </Tabs>
                            </InputGroup>
                        </>
                    )}
                    {values[`${settings.id}NatOrInternational`] === "national" && (
                        <>
                            <AddressLookUp
                                addressId={settings.id}
                                showText={showText}
                                innerTitle={settings.displayText}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                handleKeyup={handleKeyup}
                                values={values}
                                errors={errors}
                                includeNickName={includeNickName}
                                country="Ireland"
                                onMount={addressLookupLoad}
                                disableManualEntry={settings.disableManualEntry}
                            />
                        </>
                    )}

                    {values[`${settings.id}NatOrInternational`] === "international" && (
                        <>
                            <AddressInternational handleChange={handleChange} handleKeyup={handleKeyup} handleBlur={handleBlur} values={values} errors={errors} addressId={settings.id} />
                        </>
                    )}
                </FormGroup>
            )}
        </>
    );
};

export default withRouter(AddressTemplate);

// props validation
AddressTemplate.propTypes = {
    showText: PropTypes.bool,
    handleBlur: PropTypes.func,
    handleChange: PropTypes.func,
    handleKeyup: PropTypes.func,
    errors: PropTypes.object,
    includeNickName: PropTypes.bool,
    settings: PropTypes.object
};
